class MainPDPGallery extends HTMLElement {
	constructor() {
		super();
		this.swiperInstance = null;
		this.swiperEl = null;
		this.handleResize = this.handleResize.bind(this);
		this.handleWindowLoad = this.handleWindowLoad.bind(this);
		this.loadListenerAttached = false;
	}

	connectedCallback() {
		this.swiperEl = this.querySelector('.swiper-pdp-gallery');
		if (!this.swiperEl) return;

		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	}

	initSwiper() {
		if (typeof Swiper === 'undefined') {
			if (!this.loadListenerAttached) {
				window.addEventListener('load', this.handleWindowLoad, { once: true });
				this.loadListenerAttached = true;
			}
			return;
		}

		const sectionId = this.getAttribute('data-section-id');
		const showPagination = this.getAttribute('data-show-pagination') === 'true';
		const slidesPerViewDesktop = this.getAttribute('data-slides-per-view-desctop') || 1;
		const slidesPerViewTablet = this.getAttribute('data-slides-per-view-tablet') || 1;
		const slidesPerViewMobile = this.getAttribute('data-slides-per-view-mobile') || 1;


		const config = {
			slidesPerView: slidesPerViewMobile,
			spaceBetween: 0,
			loop: false
		};

		config.pagination = {
			el: `.swiper-pdp-gallery-pagination[data-section-id="${sectionId}"]`,
			clickable: true
		};

		this.swiperInstance = new Swiper(this.swiperEl, config);
	}

	destroySwiper() {
		if (this.swiperInstance) {
			this.swiperInstance.destroy(true, true);
			this.swiperInstance = null;
		}
	}

	handleResize() {
		if (!this.swiperEl) return;

		const isSmallViewport = window.innerWidth <= 991;

		if (!isSmallViewport) {
			this.destroySwiper();
			return;
		}

		if (this.swiperInstance || this.swiperEl.swiper) return;

		this.initSwiper();
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this.handleResize);
		if (this.loadListenerAttached) {
			window.removeEventListener('load', this.handleWindowLoad);
			this.loadListenerAttached = false;
		}
		this.destroySwiper();
	}

	handleWindowLoad() {
		this.loadListenerAttached = false;
		this.handleResize();
	}
}

if (!customElements.get('pdp-gallery-slider')) {
	customElements.define('pdp-gallery-slider', MainPDPGallery);
}